import AuthHelper from 'helpers/auth_helper'
import { bothRolesProfiles, clientProfiles, talentProfiles } from 'helpers/globals'

function getProfileByCategory(category, profiles) {
  if (!category || !profiles) return null
  const profile = profiles.find(p => {
    const { type, gender } = category.filters || {}
    if (!type) return false
    const genderMatch = gender ? gender.some(g => g === p.data.gender) : true
    const typeMatch = type.includes(p.profile_type)
    return typeMatch && genderMatch
  })

  return profile
}

function getProfileLabel(profile) {
  if (!profile) return null
  return [profile.data.gender, profile.profile_type].filter(v => !!v).join(' ')
}

function hasClientProfile(user = AuthHelper.currentUser()) {
  if (!user || user.profiles.length === 0) return false

  const targetProfiles = [...clientProfiles, ...bothRolesProfiles]
  return user.profiles.some(p => targetProfiles.includes(p.profile_type))
}

function hasTalentProfile(user = AuthHelper.currentUser()) {
  if (!user || user.profiles.length === 0) return false

  const targetProfiles = [...talentProfiles, ...bothRolesProfiles]
  return user.profiles.some(p => targetProfiles.includes(p.profile_type))
}

function hasModelProfile(user = AuthHelper.currentUser()) {
  if (!user.profiles) return false
  return user.profiles.some(p => p.profile_type === 'Model')
}

const ProfileHelpers = {
  hasModelProfile,
  getProfileLabel,
  getProfileByCategory,
  hasClientProfile,
  hasTalentProfile
}

export default ProfileHelpers
